import React from "react";
import "./StatusBadge.css";

/**
 * Badge de estado genérico.
 *
 * No conoce ningún estado del negocio: recibe el color YA RESUELTO por el
 * backend y el texto ya traducido. Si aparece un estado nuevo en el backend,
 * este componente no se toca.
 *
 * @param {string|null} color  "red" | "yellow" | "blue" | "green" | "black" | null
 * @param {string} label       texto listo para mostrar (ej. "En proceso")
 */
const KNOWN_COLORS = ["red", "yellow", "blue", "green", "black"];

function StatusBadge({ color, label, className = "" }) {
  if (!label) return null;

  // color null (llega con ?include_finished=1) o un color que todavía no
  // conocemos: se pinta neutro en vez de romper.
  const variant = KNOWN_COLORS.includes(color) ? color : "neutral";

  return (
    <span
      className={`status-badge status-badge--${variant} ${className}`.trim()}
      title={label}
    >
      {label}
    </span>
  );
}

export default StatusBadge;
